// Pure logic extracted for S21 (RN06.1/RN06.2 — HU-06): dragging a document thumbnail from one
// position to another renumbers "documentOrder" contiguously and coherently with the new order.
// Kept free of React/API so it is directly unit-testable; the caller (DocumentsCarouselView)
// persists the resulting documentOrder values with the existing PUT /document/update.

/**
 * @param {Array<{uuid: string, documentOrder: number}>} documents current documents, already
 * ordered as displayed (ascending documentOrder, same as document/getAll)
 * @param {number} sourceIndex index of the dragged thumbnail
 * @param {number} destinationIndex index where the thumbnail was dropped
 * @returns {Array<{uuid: string, documentOrder: number}>} a NEW array (same references reused,
 * except each document gets its recomputed documentOrder) reflecting the new order; the
 * original array is returned untouched when there is nothing to reorder
 */
const reorderDocuments = (documents = [], sourceIndex, destinationIndex) => {
  const isValidIndex = (index) => index >= 0 && index < documents.length
  if (!isValidIndex(sourceIndex) || !isValidIndex(destinationIndex) || sourceIndex === destinationIndex) {
    return documents
  }
  const baseOrder = documents.reduce(
    (min, document) => Math.min(min, document.documentOrder),
    documents[0].documentOrder
  )
  const reordered = [...documents]
  const [movedDocument] = reordered.splice(sourceIndex, 1)
  reordered.splice(destinationIndex, 0, movedDocument)
  return reordered.map((document, index) => ({ ...document, documentOrder: baseOrder + index }))
}

export { reorderDocuments }
